/**
 * Check if a port number is valid (1–65535).
 * Works with numbers or numeric strings.
 * @param {number|string} port - The port to validate.
 * @returns {boolean} True if valid, otherwise false.
 */
export const isValidPort = (port) => {
    // Reject undefined inputs
    if (!port) {
        return false;
    }

    // Convert to number
    const num = Number(port);

    // Reject non-numeric inputs
    if (Number.isNaN(num)) {
        return false;
    }

    // Must be an integer in valid port range
    return Number.isInteger(num) && num >= 1 && num <= 65535;
};
